import { MenuRow } from './MenuRow';
import { MenuSurface } from './MenuSurface';
import type { DeckMenuAction, HeaderTheme } from './theme';
import { useV15Theme } from '~/design-system/components/v1_5/theme-context';

export interface DeckMenuProps {
  onAction?: (action: DeckMenuAction) => void;
  theme?: HeaderTheme;
  className?: string;
}

/** 248px wide, anchored left edge to the title's left edge. */
export const DECK_MENU_WIDTH = 248;

const ROWS: Array<{ id: DeckMenuAction; icon: string; label: string }> = [
  { id: 'rename', icon: 'edit', label: 'Rename' },
  { id: 'duplicate', icon: 'Copy', label: 'Duplicate' },
  { id: 'history', icon: 'clock', label: 'Version history' },
  { id: 'move', icon: 'uploads', label: 'Move to folder' },
];

/**
 * The deck menu, off the title caret. Delete is set apart by a 4px spacer rather than a rule —
 * the only grouping device v1.5 has.
 */
export function DeckMenu({ onAction, theme: themeProp, className }: DeckMenuProps) {
  const theme = useV15Theme(themeProp);
  return (
    <MenuSurface width={DECK_MENU_WIDTH} theme={theme} label="Deck" className={className}>
      {ROWS.map((row) => (
        <MenuRow
          key={row.id}
          icon={row.icon}
          label={row.label}
          theme={theme}
          onClick={() => onAction?.(row.id)}
        />
      ))}
      <MenuRow
        icon="delete-bin-6"
        label="Delete deck"
        destructive
        theme={theme}
        onClick={() => onAction?.('delete')}
      />
    </MenuSurface>
  );
}
